module.exports = __webpack_public_path__ + "static/media/bg1.106aafa1.png";